import { render, staticRenderFns } from "./InventoryIngressDrawer.vue?vue&type=template&id=f12ecdde"
import script from "./InventoryIngressDrawer.vue?vue&type=script&lang=js"
export * from "./InventoryIngressDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports